module.exports = __webpack_public_path__ + "img/home-circle-2.ae27ea11.png";